export default __webpack_public_path__ + "static/media/T14D.ea8d9980.png";